/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly payment`)
};

const es_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pago mensual`)
};

const de_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatliche Rate`)
};

const nl_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maandelijkse betaling`)
};

const fr_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paiement mensuel`)
};

const it_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento mensile`)
};

const pt_br2_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento mensal`)
};

const pt_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagamento mensal`)
};

const ja_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`「月々の支払額」`)
};

const zh_ln_monthly_out = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月供`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ln_monthly_out = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ln_monthly_out(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ln_monthly_out", locale)
	if (locale === "en") return en_ln_monthly_out(inputs)
	if (locale === "es") return es_ln_monthly_out(inputs)
	if (locale === "de") return de_ln_monthly_out(inputs)
	if (locale === "nl") return nl_ln_monthly_out(inputs)
	if (locale === "fr") return fr_ln_monthly_out(inputs)
	if (locale === "it") return it_ln_monthly_out(inputs)
	if (locale === "pt-BR") return pt_br2_ln_monthly_out(inputs)
	if (locale === "pt") return pt_ln_monthly_out(inputs)
	if (locale === "ja") return ja_ln_monthly_out(inputs)
	return zh_ln_monthly_out(inputs)
};